import Skeleton from 'react-loading-skeleton';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  notes: string | undefined;
  loading: boolean;
}

const OrderNotes: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  if (!props.notes || props.notes.trim().length === 0) return null;

  return (
    <div className="order-notes d-flex flex-column bg-graysoft p-2">
      <h2 className="family-bold color-dark text-size-10 text-uppercase letter-spacing-12 mb-1">{localeStore.t('order_notes')}</h2>
      <p className="family-regular color-dark text-size-14 letter-spacing-5">{props.loading ? <Skeleton width={250} /> : props.notes}</p>
    </div>
  );
};

export default OrderNotes;
